export default __webpack_public_path__ + "static/media/vrf2.9d738b0f.jpg";